module.exports = __webpack_public_path__ + "img/message.11a5e39c.svg";